import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./myComponents/NavBar.js";
import { Home } from './myComponents/Home.js';
import { Skills } from './myComponents/Skills.js';
import { Projects } from './myComponents/Projects.js';
import { ContactMe } from './myComponents/ContactMe.js';
import { LanguageProvider } from "./context/LanguageContext";



function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <NavBar/>
        <Home />
        <Skills/>
        <Projects/>
        <ContactMe/>
      </div>
    </LanguageProvider>
  );
}

export default App;
